import { c as _c } from "react/compiler-runtime";
import { RightColumnSkeleton } from '../breaking-views/right-column-skeleton';
import { FeaturedMarketHeroSkeleton } from './featured-market-hero-skeleton';
export function MarketsFeaturedSkeleton() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="md:basis-[70%] md:max-w-[70%] md:shrink-0"><FeaturedMarketHeroSkeleton /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="hidden w-full md:mb-2 md:flex md:gap-4 md:items-stretch" data-testid="featured-market-hero-skeleton-wrapper">{t0}<div className="relative md:flex-1 md:min-w-0"><div className="md:absolute md:inset-0 flex min-h-0 flex-col"><RightColumnSkeleton className="flex-1 gap-4" /></div></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}